import wishListStateManager from '@src/quince-site-common/src/redux/globalStateManager/WishlistStateManager'
import productService from '@src/quince-site-common/src/services/productService'
import wishlistService from '@src/quince-site-common/src/services/wishlistService'
import AuthUtil from '@src/quince-site-common/src/utils/authUtil'

import { SharedWishListDataType, WishlistItem } from './wishlist.types'

export const fetchUserWishList = async (): Promise<WishlistItem[]> => {
  const wishListItems = AuthUtil.isLoggedIn()
    ? await wishlistService.wishListAlreadyLoggedIn(AuthUtil.getUser().email ?? '')
    : wishlistService.fetchUserWishListFromLocalStorage()
  wishListStateManager.setWishlistTotalItemsCount(wishListItems.length)
  const productList = await productService.getProductCards({
    shopifyProductIds: wishListItems.map(wishListItems => wishListItems.product_id),
    colors: wishListItems.map(wishListItems => wishListItems.color),
  })
  return productList
}

export const fetchSharedWishList = async (id: string): Promise<SharedWishListDataType> => {
  const res = await wishlistService.getSharedWishlist(id)
  const wishListItems = res.wishlist ?? []

  const ownWishListItems = AuthUtil.isLoggedIn()
    ? await wishlistService.wishListAlreadyLoggedIn(AuthUtil.getUser().email ?? '')
    : wishlistService.fetchUserWishListFromLocalStorage()

  wishListStateManager.setWishlistTotalItemsCount(ownWishListItems.length)
  const productList = await productService.getProductCards({
    shopifyProductIds: wishListItems.map(wishListItems => wishListItems.product_id),
    colors: wishListItems.map(wishListItems => wishListItems.color),
  })
  return { wishListItems: productList, name: res.user_name }
}
